import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Select, FormControl, InputLabel } from '@material-ui/core';
import { blue, neutral } from '../theme/colors';
import TextStyles, { fontFamilies } from '../theme/text';

const EmbeddedSelectControl = withStyles({
  root: {
    margin: 0,
    '& .MuiInputLabel-root': {
      background: 'white',
      color: neutral[600],
      fontFamily: fontFamilies.heading,
      fontWeight: 300,
      fontSize: '14px'
    },
    '& .MuiInputBase-root': {
      fontFamily: fontFamilies.heading,
      fontSize: TextStyles.h2.fontSize,
      minWidth: 100,
      '&.Mui-focused fieldset': {
        borderColor: blue[300]
      },
      '&.Mui-focused .MuiSelect-root': {
        backgroundColor: neutral[100]
      }
    },
    '& .MuiSelect-icon': {
      right: -8
    }
  }
})(FormControl);

export interface EmbeddedSelectProps {
  /** id of the `<select>` */
  id: string;
  /** Name of the input shown in the `<label>` */
  title: string;
  /** onChange handler */
  handleChange: (
    event: React.ChangeEvent<{
      name: string | undefined;
      value: string | number;
    }>,
    child: React.ReactNode
  ) => void;
  /** onBlur handler */
  handleBlur?: React.FocusEventHandler<any>;
  /** Set of `<option>` tags for each option in the select menu */
  options: React.ReactElement<HTMLOptionElement>[];
  /** Currently selected value */
  value: string | number;
}

/**
 * Outlined Select, select component based styled MUI FormControl
 */
const EmbeddedSelect = ({
  id,
  title,
  handleChange,
  handleBlur,
  options,
  value
}: EmbeddedSelectProps) => {
  return (
    <EmbeddedSelectControl variant="outlined" margin="dense">
      <InputLabel>{title}</InputLabel>
      <Select native id={id} value={value} onChange={handleChange} onBlur={handleBlur}>
        {options}
      </Select>
    </EmbeddedSelectControl>
  );
};
export default EmbeddedSelect;
